import { useMutation, useQueryClient } from "@tanstack/react-query";
import { type SignUpCommand, postAuthSignUp } from "Infrastructure/Api/Api";
import { getUsersQueryKey } from "Users/Api/Queries/useUsersQuery";

export function useSignUpMutation() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (data: SignUpCommand) => postAuthSignUp(data),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: getUsersQueryKey(0, 100),
			});
		},
	});
}
